module.exports = __webpack_public_path__ + "0b36711e0ce77c05da416d628a31b3a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-320.jpg
// module id = 426
// module chunks = 0